import { Component, Input } from '@angular/core';
import { ProvidersService } from 'fccore2';
import { FcinputComponent } from '../fcinput';
/**
 * fc-linké¾æ¥
 * 
 * é¾æ¥ç»ä»¶ã
 * 
 * ç¹å»éè¦è·³è½¬å°å¶ä»ç½åæå°åã
 * 
 */
@Component({
    selector: 'fc-link',
    template: `
    <a class="fc-link" [ngClass]="{'fc-link-hasline':fcHasline==='Y'}" [href] = "fcHref"
    [style.color]="fcColor" [style.display] = "'inline-block'" [style.fontsize]="fcSize"
    >{{fcLabel}}</a>
    `,
    styles: [
        `
        .fc-link-hasline{
            border-bottom:1px solid #000;
        }
        :host ::ng-deep .fc-readonly .ant-input-number-input-wrap{
            background-color: #ccc;
        } 
        `
    ]
})
export class FclinkComponent extends FcinputComponent {
     /**åç§°*/
    @Input()
    fcLabel: string;
     /**æ¯å¦æçº¿*/
    @Input()
    fcHasline: string;
    _hasLine:boolean;
     /**è®¾ç½®å­ä½é¢è²*/
    @Input()
    fcColor: string;
     /**è®¾ç½®å­ä½çå¤§å°*/
    @Input()
    fcSize:string;
     /**é¾æ¥è·³è½¬*/
    @Input()
    fcHref:string;
    constructor(public provider: ProvidersService) {
        super(provider, 'fc-link');
         /**å¦æä¸ºç©ºæ¶fcLabelç­äºç©º*/
        if (this.fcLabel === undefined) {
            this.fcLabel = '';
        }
         /**å¦ææªç©ºå·¦ä¾§ç«æ¡ä¸æ¾ç¤º*/
        if (this.fcHasline === undefined || 'N') {
            this._hasLine = false;
        }
    }

    ngOnChanges(param): void {
        super.ngOnChanges(param);
    }
    _afterParentInit(){
         /**å¦æç­äºYå·¦ä¾§ç«æ¡æ¾ç¤º*/
        if (this.fcHasline === 'Y') {
            this._hasLine = true;
        }else{
            this._hasLine = false;
        }
    }
}
